import { I2C } from "../../PCBHelper/constants";
import { HOLD, SETUP } from "../../Result/Public/waveform/Mark/markConstant";

function getPPROCTimeRange({ interfaceTag, type, data, clkEdges }) {
  let result = {}
  switch (interfaceTag) {
    case I2C:
      if (type === HOLD) {
        //SCL falling t2 -> SDA rising/falling t2

        //rising: data.timeRising[1] - data.hold_time, falling: data.timeFalling[1] - data.hold_time
        /*  const start = data.isRising ? data.timeRising[1] - data.hold_time : data.timeFalling[1] - data.hold_time;
         const clkEdge = getClkEdgeByTime(clkEdges, start, "min");
         let clkStart = null;
         if (clkEdge && !clkEdge.isRising) {
           clkStart = clkEdge.timeFalling[1];
         }
         result.start = clkStart !== null && !isNaN(clkStart) ? clkStart : start;
         result.clkType = "start"; */
      }
      if (type === SETUP) {
        //SDA rising/falling t2 -> SCL rising t1

        //rising: data.timeRising[1] + data.setup_time , falling: data.timeFalling[1] + data.setup_time
        /*      const end = data.isRising ? data.timeRising[1] + data.setup_time : data.timeFalling[1] + data.setup_time;
             const clkEdge = getClkEdgeByTime(clkEdges, end, "max");
             let clkEnd = null;
             if (clkEdge && clkEdge.isRising) {
               clkEnd = clkEdge.timeRising[0];
             }
             result.end = clkEnd !== null && !isNaN(clkEnd) ? clkEnd : end;
             result.clkType = "end"; */
      }
      break;
    //todo other gpio type
    default: break;
  }
  return { ...result }
}

/* function getClkEdgeByTime(clkEdges, number, type = "min") {
  let findEdge = null;
  if (type === "min") {
    const filterEdges = clkEdges.filter(item => number - item.t_stop >= 0);
    findEdge = filterEdges.length ? filterEdges[filterEdges.length - 1] : null;
  } else {
    const filterEdges = clkEdges.filter(item => item.t_start - number >= 0);
    findEdge = filterEdges.length ? filterEdges[0] : null;
  }

  return findEdge;

} */

const PPROC_VERSION = "0.0.2";//0.0.2 is new pproc

export {
  getPPROCTimeRange,
  PPROC_VERSION
}